export type LandingVariant = "meridian";

export const LANDING_LAYOUT_PREVIEW_MODE = "landing-layouts";

export const DEFAULT_LANDING_VARIANT: LandingVariant = "meridian";

export const LANDING_VARIANTS = [
  {
    id: "meridian",
    label: "Meridian (v4)",
    shortLabel: "Meridian",
    description:
      "Selected landing direction: the Zom marketing handoff with hero, product theater, security, FAQ, CTA, and footer.",
    accent: "var(--zom-accent-primary)",
    tone: "rgba(var(--zom-accent-primary-rgb), 0.16)",
  },
] as const satisfies readonly {
  id: LandingVariant;
  label: string;
  shortLabel: string;
  description: string;
  accent: string;
  tone: string;
}[];

export function isLandingVariant(
  value: string | null | undefined,
): value is LandingVariant {
  return LANDING_VARIANTS.some((variant) => variant.id === value);
}

export function resolveLandingVariant(
  value: string | null | undefined,
): LandingVariant {
  return isLandingVariant(value) ? value : DEFAULT_LANDING_VARIANT;
}
